
(function () {
  'use strict';

  var BAR_SEL    = '.east-trust-bar';
  var TICKER_SEL = '.east-trust-ticker';
  var SLICK_JS   = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js';
  var JQUERY_JS  = 'https://cdn.jsdelivr.net/npm/jquery@3.7.1/dist/jquery.min.js';

  function loadScript(src, cb) {
    /* Reuse if already loading / loaded */
    var existing = document.querySelector('script[src="' + src + '"]');
    if (existing) {
      if (window.jQuery && jQuery.fn && jQuery.fn.slick) { cb(); return; }
      existing.addEventListener('load', cb);
      return;
    }
    var s = document.createElement('script');
    s.src   = src;
    s.async = true;
    s.onload = cb;
    document.head.appendChild(s);
  }

  function duplicateToFill(ticker) {
    /* Measure one set of items */
    var items    = ticker.querySelectorAll('.east-trust-item');
    if (!items.length) return;

    /* Temporarily make visible to measure */
    ticker.style.visibility = 'hidden';
    ticker.style.opacity    = '1';

    var setWidth = 0;
    items.forEach(function (el) { setWidth += el.offsetWidth; });

    ticker.style.visibility = '';
    ticker.style.opacity    = '';

    if (setWidth === 0) return;

    /* How many full copies do we need to cover 3× viewport width (safe buffer) */
    var needed = Math.ceil((window.innerWidth * 3) / setWidth) + 1;
    /* Already have 1 copy — add the rest */
    var copies = Math.max(needed - 1, 5); /* minimum 5 extra copies */

    var fragment = document.createDocumentFragment();
    for (var i = 0; i < copies; i++) {
      items.forEach(function (el) {
        var clone = el.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        /* Remove Shopify block attributes from clones */
        clone.removeAttribute('data-shopify-editor-block');
        fragment.appendChild(clone);
      });
    }
    ticker.appendChild(fragment);
  }

function initTicker() {
  var $ = window.jQuery;
  if (!$ || !$.fn || !$.fn.slick) return;

  $(BAR_SEL).each(function () {
    var $bar = $(this);
    var $ticker = $bar.find(TICKER_SEL);

    if (!$ticker.length) return;

    // Destroy if already initialized
    if ($ticker.hasClass('slick-initialized')) {
      $ticker.slick('unslick');
    }

    // Remove old clones (important for re-init)
    $ticker.find('[aria-hidden="true"]').remove();

    // Duplicate items
    duplicateToFill($ticker[0]);

    var speed = parseInt($bar.data('speed'), 10) || 18000;

    $ticker.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      speed: speed,
      cssEase: 'linear',
      arrows: false,
      dots: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      variableWidth: true,
      swipe: false,
      touchMove: false,
      draggable: false,
      accessibility: false
    });
  });
}
  function boot() {
    if (window.jQuery && jQuery.fn && jQuery.fn.slick) {
      initTicker();
    } else if (window.jQuery) {
      loadScript(SLICK_JS, initTicker);
    } else {
      loadScript(JQUERY_JS, function () {
        loadScript(SLICK_JS, initTicker);
      });
    }
  }

  /* Run after DOM is ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Shopify theme editor live reload */
document.addEventListener('shopify:section:load', function (e) {
  var bars = e.target.querySelectorAll(BAR_SEL);
  if (bars.length) {
    bars.forEach(function (bar) {
      var ticker = bar.querySelector(TICKER_SEL);
      if (ticker) {
        ticker.querySelectorAll('[aria-hidden="true"]').forEach(function (el) {
          el.remove();
        });
      }
    });
    boot();
  }
});

})();
